{
  "_comment": "Frozen snapshot of KissKissBankBank's top collections, captured once from the KKBB GraphQL API on 2026-09-16. KKBB is no longer active, so this list cannot change and is never refetched. Amounts are euros; `backersCount` is the KKBB `kissbankersCount` (distinct backers), not its order or contribution count.",
  "capturedAt": "2026-09-16",
  "source": "KKBB GraphQL — projects sorted by funded amount, descending",
  "projects": [
    {
      "name": "Projet Odyssée",
      "url": "https://www.kisskissbankbank.com/fr/projects/odyssee",
      "image": "odyssee.jpg",
      "amountEur": 2270511,
      "backersCount": 29161,
      "fundingPercent": 4541,
      "categories": ["Patrimoine"]
    },
    {
      "name": "Le retour des aventures du Pyro-Barbare et de Billy",
      "url": "https://www.kisskissbankbank.com/fr/projects/la-lance-de-valkar",
      "image": "la-lance-de-valkar.jpg",
      "amountEur": 2020302,
      "backersCount": 16378,
      "fundingPercent": 5772,
      "categories": ["Livre & Édition"]
    },
    {
      "name": "Les nouvelles aventures du Pyro-Barbare et de Billy",
      "url": "https://www.kisskissbankbank.com/fr/projects/la-corne-des-sables-d-ivoire",
      "image": "la-corne-des-sables-d-ivoire.jpg",
      "amountEur": 1878112,
      "backersCount": 20168,
      "fundingPercent": 5366,
      "categories": ["Livre & Édition", "Youtubers", "Roman"]
    },
    {
      "name": "COGITO : (super)parcours et certification",
      "url": "https://www.kisskissbankbank.com/fr/projects/lespritcritique",
      "image": "lespritcritique.jpg",
      "amountEur": 1859590,
      "backersCount": 24042,
      "fundingPercent": 3719,
      "categories": ["Journalisme"]
    },
    {
      "name": "Les aventures du Pyro-Barbare",
      "url": "https://www.kisskissbankbank.com/fr/projects/les-aventures-du-pyro-barbare-par-bob-lennon",
      "image": "les-aventures-du-pyro-barbare.jpg",
      "amountEur": 1835572,
      "backersCount": 25286,
      "fundingPercent": 5244,
      "categories": ["Films & vidéos", "Livre & Édition"]
    },
    {
      "name": "Le Multipla le plus rapide du monde — Multipla AMG stage 1000",
      "url": "https://www.kisskissbankbank.com/fr/projects/multiplamg-stage-1000-milletipla",
      "image": "multipla-amg.jpg",
      "amountEur": 1096111,
      "backersCount": 19701,
      "fundingPercent": 2192,
      "categories": ["Films & vidéos", "Patrimoine"]
    },
    {
      "name": "Blast",
      "url": "https://www.kisskissbankbank.com/fr/projects/blast-94de91ba-1700-45f2-924b-c3c3bc8eb944",
      "image": "blast.jpg",
      "amountEur": 903031,
      "backersCount": 9765,
      "fundingPercent": 903,
      "categories": ["Journalisme", "Investigation", "Reportage"]
    },
    {
      "name": "Les Vikings par Nota Bene",
      "url": "https://www.kisskissbankbank.com/fr/projects/notabene",
      "image": "notabene.jpg",
      "amountEur": 813528,
      "backersCount": 13054,
      "fundingPercent": 2324,
      "categories": ["Livre & Édition", "Youtubers"]
    },
    {
      "name": "Premier Virage",
      "url": "https://www.kisskissbankbank.com/fr/projects/depielo",
      "image": "depielo.jpg",
      "amountEur": 644099,
      "backersCount": 9834,
      "fundingPercent": 1840,
      "categories": ["Livre & Édition"]
    },
    {
      "name": "Les Samouraïs",
      "url": "https://www.kisskissbankbank.com/fr/projects/les-samourais-par-nota-bene",
      "image": "les-samourais.jpg",
      "amountEur": 527944,
      "backersCount": 6812,
      "fundingPercent": 1508,
      "categories": ["Livre & Édition"]
    }
  ]
}
